var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTranslate = function SvgIconTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_translate_svg2__a",
    x1: 14.38,
    x2: 91.05,
    y1: 72.9,
    y2: 18.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_translate_svg2__a",
    id: "icon_translate_svg2__b",
    x1: 27.01,
    x2: 103.69,
    y1: 90.7,
    y2: 36.28
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "31 - 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.64 33.43h-25V18.66c0-6.27-5.09-11.36-11.36-11.36H11.36C5.09 7.3 0 12.38 0 18.65v27.27c0 6.27 5.09 11.36 11.36 11.36v4.75c0 1.83 1.1 3.49 2.8 4.19 1.7.71 3.67.32 4.97-.99.08-.08.16-.17.23-.26l5.65-7.69h11.35v14.77c0 6.27 5.09 11.36 11.36 11.36h25.2l7.95 7.95a4.557 4.557 0 0 0 6.43 0 4.55 4.55 0 0 0 1.33-3.21v-4.74c6.27 0 11.36-5.09 11.36-11.36V44.78c0-6.27-5.09-11.36-11.36-11.36ZM23.86 52.74c-.72 0-1.39.35-1.82.92l-6.14 8.32v-6.97c0-1.26-1.02-2.27-2.27-2.27h-2.27c-3.77 0-6.82-3.05-6.82-6.82V18.65c0-3.77 3.05-6.82 6.82-6.82h40.91c3.77 0 6.82 3.05 6.82 6.82v14.77H47.73c-2.42 0-4.77.79-6.71 2.24l-7.13-15.68a2.277 2.277 0 0 0-3.01-1.13c-.5.23-.9.63-1.13 1.13l-11.36 25a2.277 2.277 0 0 0 1.13 3.01c.29.14.61.21.93.21.89 0 1.7-.52 2.07-1.33l3.53-7.76h11.54l.16.35c-.9 1.63-1.38 3.47-1.39 5.33v7.95zm11.67-18.18h-7.41l3.7-8.15zm59.92 37.5c0 3.77-3.05 6.82-6.82 6.82h-2.27c-1.26 0-2.27 1.02-2.27 2.27v7.01l-8.62-8.62c-.43-.43-1-.67-1.61-.67H47.72c-3.77 0-6.82-3.05-6.82-6.82V44.78c0-3.77 3.05-6.82 6.82-6.82h40.91c3.77 0 6.82 3.05 6.82 6.82v27.27Z",
    style: {
      fill: "url(#icon_translate_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55 50.47h-9.09v-4.55c0-1.26-1.02-2.27-2.27-2.27s-2.27 1.02-2.27 2.27v4.55h-9.09c-1.26 0-2.27 1.02-2.27 2.27s1.02 2.27 2.27 2.27h16.86c-.56 3.86-2.52 7.38-5.51 9.88a15.8 15.8 0 0 1-4.14-5.34 2.27 2.27 0 1 0-4.15 1.85c.01.03.03.06.05.1 1.06 2.19 2.5 4.17 4.26 5.85-2.02.86-4.19 1.3-6.39 1.3-1.22 0-2.2 1-2.19 2.21v.06a2.337 2.337 0 0 0 2.35 2.27c3.61 0 7.16-.97 10.27-2.8a20.75 20.75 0 0 0 10.34 2.8c1.22 0 2.2-1 2.19-2.21v-.06a2.337 2.337 0 0 0-2.35-2.27c-2.13 0-4.23-.45-6.18-1.29 3.39-3.29 5.52-7.66 6.05-12.35h1.27c1.26 0 2.27-1.02 2.27-2.27s-1.02-2.27-2.27-2.27Z",
    style: {
      fill: "url(#icon_translate_svg2__b)"
    }
  })));
};
export default SvgIconTranslate;